// extracted by mini-css-extract-plugin
export default {"kanbanTypo":"index-module__Q6zVL","proseKanban":"index-module__IBbfk","listSingleLine":"index-module__N77Mn"};